import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, Eye, Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Button } from "../ui/button";
import { Card } from "../ui/card";
import { StatusBadge, OLIVE, errMsg, fmtDateTime, openPdf } from "./dpaUtils";

export const TemplatesTab = () => {
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/dpa/templates").then(({ data }) => setItems(data.items)); }, []);
  const create = async (from) => {
    try {
      const { data } = await api.post("/dpa/templates", { from_template_id: from || null });
      toast.success(`Draft v${data.version} created`);
      nav(`/compliance/templates/${data.id}`);
    } catch (e) { toast.error("Could not create draft", { description: errMsg(e) }); }
  };
  const published = items.find((t) => t.status === "published");
  return (
    <Card className="rounded-none" data-testid="templates-tab">
      <div className="p-4 flex items-center justify-between border-b" style={{ borderColor: "var(--hi-border)" }}>
        <div className="text-sm text-muted-foreground">Published templates are immutable — changes always create a new version. Agreements keep the exact wording they were issued with.</div>
        <Button className="rounded-none text-white" style={OLIVE} onClick={() => create(published?.id)} data-testid="new-template-version-btn">
          <Plus className="h-4 w-4 mr-1" />{published ? "New version from published" : "New draft"}
        </Button>
      </div>
      <table className="w-full text-sm">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-muted-foreground">
          <th className="px-4 py-2">Version</th><th className="px-4 py-2">Status</th><th className="px-4 py-2">Created</th>
          <th className="px-4 py-2">Published</th><th className="px-4 py-2">Agreements using it</th><th className="px-4 py-2">Actions</th></tr></thead>
        <tbody>
          {items.map((t) => (
            <tr key={t.id} className="border-t" style={{ borderColor: "var(--hi-border)" }} data-testid={`template-row-${t.version}`}>
              <td className="px-4 py-2 font-semibold">v{t.version}</td>
              <td className="px-4 py-2"><StatusBadge status={t.status} testId={`template-status-${t.version}`} /></td>
              <td className="px-4 py-2 text-xs">{fmtDateTime(t.created_at)} · {t.created_by}</td>
              <td className="px-4 py-2 text-xs">{t.published_at ? `${fmtDateTime(t.published_at)} · ${t.published_by}` : "—"}</td>
              <td className="px-4 py-2">{t.agreements}</td>
              <td className="px-4 py-2 flex gap-1">
                <Button size="sm" variant="outline" className="rounded-none h-7" onClick={() => nav(`/compliance/templates/${t.id}`)} data-testid={`template-open-${t.version}`}>Open</Button>
                <Button size="icon" variant="ghost" className="h-7 w-7" title="Preview PDF" onClick={() => openPdf(`/dpa/templates/${t.id}/pdf`)}><Eye className="h-3.5 w-3.5" /></Button>
                <Button size="icon" variant="ghost" className="h-7 w-7" title="Copy as new draft" onClick={() => create(t.id)} data-testid={`template-copy-${t.version}`}><Copy className="h-3.5 w-3.5" /></Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </Card>
  );
};
